import { CombinedItem, SettingItem } from "./ListItem/ListItemProps";

function isSettingItem(item: CombinedItem): item is SettingItem {
  return 'sections' in item && 'adminOnly' in item;
}

export default isSettingItem;